import { Type } from "@sinclair/typebox";
import { measurementPositionSchema } from "./map-measurements.js";
const object = { additionalProperties: false };
const uuid = Type.String({ format: "uuid" });
export const interventionPolygonSchema = Type.Object({
    type: Type.Literal("Polygon"),
    coordinates: Type.Array(Type.Array(measurementPositionSchema, { minItems: 4, maxItems: 1001 }), { minItems: 1, maxItems: 1 })
}, object);
export const geometryProposalRequestSchema = Type.Object({
    id: uuid,
    expectedRevision: Type.Integer({ minimum: 0 }),
    instruction: Type.String({ minLength: 3, maxLength: 2000, pattern: "\\S" }),
    name: Type.String({ minLength: 1, maxLength: 200, pattern: "\\S" }),
    baseGeometry: interventionPolygonSchema,
    baseMeasurementId: Type.Optional(Type.String({ minLength: 1, maxLength: 120 }))
}, object);
export const geometryFrameSchema = Type.Object({
    id: uuid,
    projection: Type.Literal("EPSG:3857"),
    center: measurementPositionSchema,
    zoom: Type.Number({ minimum: 0, maximum: 22 }),
    bearing: Type.Literal(0),
    pitch: Type.Literal(0),
    width: Type.Literal(1280),
    height: Type.Literal(720),
    pixelRatio: Type.Literal(2),
    physicalWidth: Type.Literal(2560),
    physicalHeight: Type.Literal(1440),
    padding: Type.Literal(64),
    crop: Type.Null(),
    resize: Type.Null(),
    source: Type.Literal("Mapbox"),
    attribution: Type.String(),
    retrievedAt: Type.Union([Type.String(), Type.Null()]),
    imageHash: Type.Union([Type.String(), Type.Null()]),
    policyVersion: Type.Literal("intervention-frame-v1")
}, object);
export const geometryProposalProvenanceSchema = Type.Object({ kind: Type.Literal("ai_geometry"), proposalId: uuid }, object);
export const geometryProposalSchema = Type.Object({
    id: uuid,
    buildingId: uuid,
    expectedRevision: Type.Integer({ minimum: 0 }),
    state: Type.Union([
        Type.Literal("queued"),
        Type.Literal("running"),
        Type.Literal("pending"),
        Type.Literal("accepted"),
        Type.Literal("cancelled"),
        Type.Literal("failed"),
        Type.Literal("stale")
    ]),
    name: Type.String(),
    instruction: Type.String(),
    baseGeometry: interventionPolygonSchema,
    baseMeasurementId: Type.Optional(Type.String()),
    frame: geometryFrameSchema,
    geometry: Type.Union([interventionPolygonSchema, Type.Null()]),
    areaM2: Type.Union([Type.String(), Type.Null()]),
    perimeterM: Type.Union([Type.String(), Type.Null()]),
    explanation: Type.String(),
    uncertainEdges: Type.Array(Type.Integer({ minimum: 0 })),
    error: Type.Union([Type.String(), Type.Null()]),
    provenance: geometryProposalProvenanceSchema,
    createdAt: Type.String()
}, object);
export const geometryProposalCapabilitySchema = Type.Object({ enabled: Type.Boolean(), reason: Type.Union([Type.String(), Type.Null()]) }, object);
export const geometryProposalAcceptSchema = Type.Object({ expectedRevision: Type.Integer({ minimum: 0 }) }, object);
export const geometryModelOutputSchema = Type.Object({
    ringNormalized: Type.Array(Type.Tuple([
        Type.Number({ minimum: 0, maximum: 1 }),
        Type.Number({ minimum: 0, maximum: 1 })
    ]), { minItems: 4, maxItems: 1001 }),
    explanation: Type.String({ minLength: 1, maxLength: 2000 }),
    uncertainEdges: Type.Array(Type.Integer({ minimum: 0, maximum: 999 }), { maxItems: 1000 })
}, object);
//# sourceMappingURL=geometry-proposals.js.map